import { PatchSurveyInterface } from '../../../../../shared/interfaces/survey.interface';

export type McTraditionalSetterData = {
  survey_id: number;
  operation: string;
  path: string;
  value: PatchSurveyInterface['value'];
};

export type McTraditionalSettings = {
  survey_id: number;
  data: PatchSurveyInterface[];
};

export class McTraditionalSurveySettingsComposer {
  private _settings: McTraditionalSettings[] = [];

  constructor() {}

  public get(): McTraditionalSettings[] {
    return this._settings;
  }

  public reset(): void {
    this._settings = [];
  }

  public remove(surveyId: number) {
    this._settings = this._settings.filter((s) => s.survey_id !== surveyId);
  }

  public set(data: McTraditionalSetterData[]): void {
    for (const eachData of data) {
      this._setEach(eachData);
    }
  }

  private _setEach(eachData: McTraditionalSetterData): void {
    const existing = this._find(eachData);
    if (!existing) {
      this._settings.push(this._fresh(eachData));
      return;
    }

    this._settings = [
      ...this._filterOutExistingSetting(existing),
      this._updated(existing, eachData),
    ];
  }

  private _find(
    eachData: McTraditionalSetterData
  ): McTraditionalSettings | undefined {
    return this._settings.find((s) => s.survey_id === eachData.survey_id);
  }

  private _fresh(eachData: McTraditionalSetterData): McTraditionalSettings {
    return {
      survey_id: eachData.survey_id,
      data: [this._eachSettingsData(eachData)],
    };
  }

  private _filterOutExistingSetting(
    existing: McTraditionalSettings
  ): McTraditionalSettings[] {
    return this._settings.filter((s) => s.survey_id !== existing.survey_id);
  }

  private _updated(
    existing: McTraditionalSettings,
    upcoming: McTraditionalSetterData
  ): McTraditionalSettings {
    return {
      ...existing,
      data: [
        ...this._filterOutExistingData(existing, upcoming),
        this._eachSettingsData(upcoming),
      ],
    };
  }

  private _filterOutExistingData(
    existing: McTraditionalSettings,
    upcoming: McTraditionalSetterData
  ): PatchSurveyInterface[] {
    return existing.data.filter(
      (item) => item.op !== upcoming.operation || item.path !== upcoming.path
    );
  }

  private _eachSettingsData(
    eachData: McTraditionalSetterData
  ): PatchSurveyInterface {
    const { operation: op, path, value } = eachData;
    return {
      op,
      path,
      value,
    };
  }
}
